import { Box, Theme, useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";
import AppLogo from "components/AppLogo";
import BaseLayout from ".";

import ButtonGoBack from "components/ButtonGoBack";
import { ReactNode } from "react";

interface BlankLayoutProps {
  title?: string;
  children?: ReactNode;
  action?: ReactNode;
}

export default function BlankLayout({
  action,
  title,
  children,
}: BlankLayoutProps) {
  const theme: Theme = useTheme();

  return (
    <BaseLayout
      showRightLogo={false}
      header={
        <Box
          sx={{
            width: "100%",
            display: "grid",
            alignItems: "center",
            justifyContent: "between",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "auto auto auto",
            },
            paddingTop: theme.spacing(6),
            paddingInline: theme.spacing(4),
            color: theme.palette.common.white,
            gridTemplateAreas: {
              xs: "'action' 'logo' 'page-title'",
              sm: "'action page-title logo'",
            },
            gridRowGap: theme.spacing(2),
          }}
        >
          <Box style={{ gridArea: "action" }}>
            <ButtonGoBack />
          </Box>
          <Box style={{ gridArea: "page-title" }}>
            {title && (
              <Typography
                variant="h1"
                display={{ xs: "none", md: "block" }}
                style={{
                  fontWeight: 700,
                  textAlign: "center",
                }}
              >
                {title}
              </Typography>
            )}
          </Box>
          <Box style={{ gridArea: "logo" }}>
            <AppLogo />
          </Box>
        </Box>
      }
    >
      {children}
    </BaseLayout>
  );
}
